import _extends from "@babel/runtime/helpers/esm/extends";

/**
 * @file input类型Search Filter
 * @author alfielv
 */
import _ from 'lodash';
import React, { useCallback } from 'react';
import { Input, OverlayTrigger, PopOver } from '@tencent/spaui'; // 校验规则类型

// 依次校验rules
var doValidate = function doValidate(rules, data) {
  var result = {
    status: 'normal',
    message: ''
  };

  _.some(rules, function (rule) {
    var pattern = rule.pattern,
        customFunction = rule.function,
        _rule$message = rule.message,
        message = _rule$message === void 0 ? '请检查输入内容' : _rule$message;

    if (pattern && !pattern.test(data) || customFunction && !customFunction(data)) {
      result = {
        status: 'error',
        message: message
      };
      return false;
    }

    return true;
  });

  return result;
};

var FilterInput = function FilterInput(props) {
  var _props$config = props.config,
      config = _props$config === void 0 ? {} : _props$config,
      name = props.name,
      title = props.title,
      searchValue = props.searchValue,
      setSearchValue = props.setSearchValue,
      inputStatus = props.inputStatus,
      setInputStatus = props.setInputStatus,
      errorMessage = props.errorMessage,
      setErrorMessage = props.setErrorMessage,
      handleFilterDataDelayUpdate = props.handleFilterDataDelayUpdate,
      rules = props.rules,
      setActive = props.setActive;
  var onChangeFromConfig = config.onChange,
      onFocusFromConfig = config.onFocus,
      onBlurFromConfig = config.onBlur;
  var handleValueChange = useCallback(function (event, data) {
    setSearchValue(data);

    var _ref = function () {
      if (!rules) {
        return {
          status: 'normal',
          message: ''
        };
      }

      return doValidate(rules, data);
    }(),
        _ref$status = _ref.status,
        status = _ref$status === void 0 ? 'normal' : _ref$status,
        _ref$message = _ref.message,
        message = _ref$message === void 0 ? '' : _ref$message;

    setInputStatus(status);
    setErrorMessage(message); // 校验通过，真正发起filterData更新

    if (status === 'normal') {
      handleFilterDataDelayUpdate === null || handleFilterDataDelayUpdate === void 0 ? void 0 : handleFilterDataDelayUpdate({
        type: 'UPDATE',
        key: name,
        value: data
      });
    }

    onChangeFromConfig === null || onChangeFromConfig === void 0 ? void 0 : onChangeFromConfig(event, data);
  }, [name, handleFilterDataDelayUpdate, rules, setInputStatus, setSearchValue, setErrorMessage, onChangeFromConfig]);
  var handleFocus = useCallback(function (event) {
    setActive(true);
    onFocusFromConfig === null || onFocusFromConfig === void 0 ? void 0 : onFocusFromConfig(event);
  }, [onFocusFromConfig, setActive]);
  var handleBlur = useCallback(function (event) {
    setActive(false);
    onBlurFromConfig === null || onBlurFromConfig === void 0 ? void 0 : onBlurFromConfig(event);
  }, [onBlurFromConfig, setActive]);
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    show: !!(rules && errorMessage),
    overlay: /*#__PURE__*/React.createElement(PopOver, {
      className: "ptp-listview__filter-validate-tip"
    }, errorMessage)
  }, /*#__PURE__*/React.createElement(Input, _extends({
    value: searchValue,
    placeholder: "\u8BF7\u8F93\u5165".concat(title),
    status: inputStatus
  }, config, {
    onChange: handleValueChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  })));
}; // 筛选搜索项


export default FilterInput;